/* eslint-disable global-require,import/no-unresolved, react/forbid-prop-types, react/no-array-index-key */
import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import styles from '../../../styles'
import textStyles from '../../../styles/text'
import { webViewTapped } from '../../../actions/tapEvents'
import * as RegionalContentLookup from '../../methods/RegionalContentLookUp'

function CRTPrecautions(props) {
  const { t, type, regionalContentLookup } = props

  function getUrl() {
    return regionalContentLookup(type === 'crtp' ? 'crtPPrecautionLinks' : 'crtDPrecautionLinks')
  }

  return (
    <View>
      <View style={textStyles.faqH1Container}>
        <Text style={[textStyles.h1, styles.shark_grey]} testID={`${type}-precautions-title`}>{t('crtPrecautionsTitle')}</Text>
      </View>
      <View>
        <Text style={[textStyles.bodyContentText]} testID={`${type}-precautions-paragraph1`}>{t('crtPrecautionsParagraph1')}</Text>
        <TouchableOpacity
          onPress={() => {
            webViewTapped(getUrl(), 'crtPrecautionsLearnMoreLink')
          }}
          accessibilityLabel={`${type} Precautions Link`}
          testID={`${type}-precautions-learn-more-link`}
        >
          <View style={styles.button}>
            <Text style={[styles.hyperlink, styles.textMargin, styles.linkText]}>
              {t('crtPrecautionsLearnMoreLink')}
            </Text>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  )
}

CRTPrecautions.propTypes = {
  regionalContentLookup: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
}

const CRTDMapStateToProps = () => ({
  type: 'crtd',
})

const CRTPMapStateToProps = () => ({
  type: 'crtp',
})

const actionCreators = {
  regionalContentLookup: RegionalContentLookup.regionalContentLookup,
}

export const CRTDPrecautions = withTranslation('faq')(connect(CRTDMapStateToProps, actionCreators)(CRTPrecautions))
export const CRTPPrecautions = withTranslation('faq')(connect(CRTPMapStateToProps, actionCreators)(CRTPrecautions))
